import { CountryService } from './../../core/services/country.service';
import { AlertService } from './../../core/services/alert.service';
import { ApiObjectData } from './../../core/models/api-object-data';
import { Teacher } from './../../core/models/teacher';
import { Component, ContentChild, ElementRef, OnInit, Pipe, ViewChild } from '@angular/core';
import { BaseComponent } from './../../components/base/base.component';
import { BaseService } from './../../core/services/base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { TeacherService } from '../../core/services/teacher.service';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { StudentService } from '../../core/services/student.service';
import { Student } from './../../core/models/student';

import { countriesCodeService } from '../../core/services/countries-code.service';
import { Country, CountryTranslation} from '../../core/models/country';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent extends BaseComponent implements OnInit {
  @ViewChild('teacherForm', { static: false }) teacherForm: NgForm;
  @ViewChild('studentForm', { static: false }) studentForm: NgForm;
  teacher = {} as Teacher;
  student = {} as Student;
  tokenValid = false;
  loading = false;

  countries: Country[];
  countriesTranslation: CountryTranslation[];

  countryCode: string;

  

  constructor(
    public baseService:BaseService,
    private teacherService: TeacherService,
    private studentService: StudentService,
    private alertService: AlertService,
    private route :ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private countryService: CountryService
  ) { super() }

  ngOnInit(): void {
    const token = localStorage.getItem('token');
    if (token) { this.tokenValid = true; }
    else { this.tokenValid = false; }

    this.countryService.gets().pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.countries = data.result.returnData
        // console.log(data)
      }
    )
  }

  onSelectTeacherCountry(e) {
    // console.log(e)
    // console.log(this.countryCode)
  }

  registerTeacher() {
    debugger
    var x = this.countryCode + this.teacher.mobile
    this.teacher.mobile = x;
    this.loading = true;
    this.teacher.name = this.teacher.firstName;
    this.teacher.surname = this.teacher.lastName;
    this.teacher.emailAddress = this.teacher.email;
    this.teacher.typeId = 2;
    this.baseService.blockStart();
    this.teacherService.save(this.teacher).pipe(takeUntil(this.ngUnsubscribe)).subscribe (
      (data: any) => {
        this.loading = false;
        this.baseService.blockStop();
        if (data.result.message.type === 'Success') {
          this.alertService.success(this.translate.instant('registeredSuccessfully'));
          this.teacher = {} as Teacher;
          this.teacherForm.reset(this.teacher);
          this.router.navigate(['/login']);
        }
        else if (data.result.message.type === 'Error') {
          this.alertService.error(data.result.message.log)
        }
        else {
          this.alertService.error(data.result.returnData);
        }
      },
      error => {
        this.baseService.blockStop();
        this.alertService.error(this.translate.instant('loginerror'));
      }
    )
  }

  registerStudent() {
    var x = this.countryCode + this.student.mobile
    this.student.mobile = x;
    this.loading = true;
    this.student.isTeacher = false;
    this.teacher.typeId = 3;
    this.baseService.blockStart();
    this.studentService.save(this.student).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.loading = false;
        this.baseService.blockStop();
        if (data.result.message.type === 'Success') {
          this.alertService.success(this.translate.instant('registeredSuccessfully'));
          this.student = {} as Student;
          this.studentForm.reset(this.student);
          this.router.navigate(['/login']);
        }
        else if (data.result.message.type === 'Error') {
          this.alertService.error(data.result.message.log)
        }
        else {
          this.alertService.error(data.result.returnData);
        }
      }
    )
  }

  changeInput(input: any): any {
    input.type = input.type === 'password' ? 'text' : 'password';
  }

  changeInputStudent(input: any): any {
    input.type = input.type === 'password' ? 'text' : 'password';
  }

}
